import $ from 'jquery'
import JsEnabledFunction from './components/jsEnabled'
import { Screenmode } from './components/screenmode'
import FocusStyleClass from './components/focusStyle'
import HeaderClass from './components/header'
import { Tracking } from './components/tracking'
import { initCookiebotOverlayHandler } from './components/helper'

if (document.querySelector('lottie-player')) {
  import('@lottiefiles/lottie-player')
}

const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  // Add class js, remove class no-js from html-tag
  JsEnabledFunction()

  // Set breakpoint classes
  const screenmode = new Screenmode()
  screenmode.init()

  // Add focus behaviour
  const focusStyle = new FocusStyleClass()
  focusStyle.init()

  // Add anchor jump
  if (document.querySelector('.btn--to-top, .btn--to-top-fixed,a[href*="#"][href*="' + window.location.host + '"],a[href^="/"][href*="#"]:not([href^="//"]),.page-header')) {
    import('./components/jumpToAnchor')
      .then(({ JumpToAnchor }) => {
        const jumpToAnchor = new JumpToAnchor()
        jumpToAnchor.init()
      })
  }

  // Add alert popup
  if (document.querySelector('.alert-popup')) {
    import('./components/alertPopup')
      .then(({ AlertPopup }) => {
        const alertPopup = new AlertPopup()
        alertPopup.init()
      })
  }

  // Add scrolling animations
  if (document.querySelector('.big-teaser--1,.big-teaser--2,.teaser-group__item,.news-list--1 .news-list__item,.page__top-image,.advantage-calculator__summary-price')) {
    import('./components/scrollingAnimation')
      .then(({ ScrollingAnimation }) => {
        const scrollingAnimation = new ScrollingAnimation()
        scrollingAnimation.init()
      })
  }

  // Add scroll function for header
  const header = new HeaderClass()
  header.init()

  // init cookiebot handling
  if (typeof Cookiebot !== 'undefined') {
    initCookiebotOverlayHandler()
  }

  // Add read more function
  if ($('.read-more').length > 0) {
    import('./components/readMore1')
      .then(({ ReadMore1 }) => {
        const readMore1 = new ReadMore1()
        readMore1.init()
      })
  }

  // add download filter
  if ($('.download-center--1').length > 0) {
    import('./components/downloadFilter1')
      .then(({ DownloadFilter1 }) => {
        const downloadFilter1 = new DownloadFilter1()
        downloadFilter1.init()
      })
  }

  // Logout section
  if ($('.logoutSection').length > 0) {
    import('./components/logoutSection')
      .then(({ LogoutSection }) => {
        const logoutSection = new LogoutSection()
        logoutSection.init()
      })
  }

  // Add dynamic select boxes, based on viewport
  if ($('.dynamic-select, select:not(.form__select--no-replace)').length > 0) {
    import('./components/dynamicSelect')
      .then(({ DynamicSelect }) => {
        const dynamicSelect = new DynamicSelect()
        dynamicSelect.init()
      })
  }

  // Add slick slider for teaser group
  if ($('.slider, .slider-only').length > 0) {
    import('./components/teaserGroup')
      .then(({ TeaserGroup }) => {
        const teaserGroup = new TeaserGroup()
        teaserGroup.init()
      })
  }

  // Add mobile slider for teaser group 7
  if (document.querySelector('.teaser-group--7')) {
    import('./components/teaserGroup7')
      .then(({ TeaserGroup7 }) => {
        const teaserGroup7 = new TeaserGroup7()
        teaserGroup7.init()
      })
  }

  // Add mobile slider for teaser group 8
  if (document.querySelector('.teaser-group--8')) {
    import('./components/teaserGroup8')
      .then(({ TeaserGroup8 }) => {
        const teaserGroup8 = new TeaserGroup8()
        teaserGroup8.init()
      })
  }

  // Add mobile slider for teaser group 9
  if (document.querySelector('.teaser-group--9')) {
    import('./components/teaserGroup9')
      .then(({ TeaserGroup9 }) => {
        const teaserGroup9 = new TeaserGroup9()
        teaserGroup9.init()
      })
  }

  // Render quiz result teaser variant 1
  if (document.querySelector('.quiz-result-teaser--1')) {
    import('./components/quizResultTeaser1')
      .then(({ QuizResultTeaser1 }) => {
        const quizResultTeaser1 = new QuizResultTeaser1()
        quizResultTeaser1.init()
      })
  }

  // Add search overlay
  if ($('.search-overlay').length > 0) {
    import('./components/searchOverlay')
      .then(({ SearchOverlay }) => {
        const searchOverlay = new SearchOverlay()
        searchOverlay.init()
      })
  }

  // Add contact overlay
  if ($('.contact-overlay').length > 0) {
    import('./components/contactOverlay')
      .then(({ ContactOverlay }) => {
        const contactOverlay = new ContactOverlay()
        contactOverlay.init()
      })
  }

  // Add info request overlay
  if ($('.info-request-overlay').length > 0) {
    import('./components/infoRequestOverlay')
      .then(({ InfoRequestOverlay }) => {
        const infoRequestOverlay = new InfoRequestOverlay()
        infoRequestOverlay.init()
      })
  }

  // Add collapse events
  if ($('.collapse-block--1').length > 0) {
    import('./components/collapse1')
      .then(({ Collapse1 }) => {
        const collapse = new Collapse1()
        collapse.init()
      })
  }

  // Change link box height
  if ($('.element-group--3').length > 0) {
    import('./components/elementGroup3')
      .then(({ ElementGroup3 }) => {
        const elementGroup3 = new ElementGroup3()
        elementGroup3.init()
      })
  }

  // Add video-1
  if ($('.video--1').length > 0) {
    import('./components/video1')
      .then(({ Video1 }) => {
        const video1 = new Video1()
        video1.init()
      })
  }

  // Add cryptshare
  if ($('.cryptshare').length > 0) {
    import('./components/cryptshare')
      .then(({ Cryptshare }) => {
        const cryptshare = new Cryptshare()
        cryptshare.init()
      })
  }

  // Add kinderkrankengeldrechner
  if ($('.kinderkrankengeldrechner').length > 0) {
    import('./components/kinderkrankengeldrechner')
      .then(({ Kinderkrankengeldrechner }) => {
        const kinderkrankengeldrechner = new Kinderkrankengeldrechner()
        kinderkrankengeldrechner.init()
      })
  }

  // Add job application
  if ($('.job-application').length > 0) {
    import('./components/jobApplication')
      .then(({ JobApplication }) => {
        const jobApplication = new JobApplication()
        jobApplication.init()
      })
  }

  // Add Icon Box 2
  if ($('.icon-box--2').length > 0) {
    import('./components/iconBox2')
      .then(({ IconBox2 }) => {
        const iconBox2 = new IconBox2()
        iconBox2.init()
      })
  }

  // Add Big Teaser 4
  if ($('.big-teaser--4').length > 0) {
    import('./components/bigteaser4')
      .then(({ Bigteaser4 }) => {
        const bigteaser4 = new Bigteaser4()
        bigteaser4.init()
      })
  }

  // Add info popup
  import('./components/infoPopup')
    .then(({ InfoPopup }) => {
      const infoPopup = new InfoPopup()
      infoPopup.init()
    })

  // Add advantage calculator
  if ($('.advantage-calculator').length > 0) {
    import('./components/advantageCalculator1')
      .then(({ AdvantageCalculator1 }) => {
        const advantageCalculator1 = new AdvantageCalculator1()
        advantageCalculator1.init()
      })
  }

  // Add journal form switch functions
  if ($('.journal_select').length > 0) {
    import('./components/journalForm')
      .then(({ JournalForm }) => {
        const journalForm = new JournalForm()
        journalForm.init()
      })
  }

  // initialize chatbot
  import('./components/chatbot')
    .then(({ Chatbot }) => {
      const chatbot = new Chatbot()
      chatbot.init()
    })

  // Add form functions
  if ($('.form__upload, .form_select, .form--validate').length > 0) {
    import('./components/forms')
      .then(({ Forms }) => {
        const forms = new Forms()
        forms.init()
      })
  }

  // Add job form switch functions
  if ($('.powermail_fieldset.doc-uploads').length > 0) {
    import('./components/jobform')
      .then(({ Jobform }) => {
        const jobForm = new Jobform()
        jobForm.init()
      })
  }

  // Add Search Dropdown
  if ($('.search-dropdown').length > 0) {
    import('./components/searchDropown')
      .then(({ SearchDropown }) => {
        const searchDropown = new SearchDropown()
        searchDropown.init()
      })
  }

  // Add table of contents list
  if ($('.table-of-contents').length > 0) {
    import('./components/tableOfContents')
      .then(({ TableOfContents }) => {
        const tableOfContents = new TableOfContents()
        tableOfContents.init()
      })
  }

  // Add modal variant 1
  if ($('.modal--1').length > 0) {
    import('./components/modal1')
      .then(({ Modal1 }) => {
        const modal1 = new Modal1()
        modal1.init()
      })
  }

  // Add modal variant 2
  if ($('.modal--2').length > 0) {
    import('./components/modal2')
      .then(({ Modal2 }) => {
        const modal2 = new Modal2()
        modal2.init()
      })
  }

  // Add modal variant 3 (Exit-Intent)
  if ($('.modal--3').length > 0) {
    import('./components/modal3')
      .then(({ Modal3 }) => {
        const modal3 = new Modal3()
        modal3.init()
      })
  }

  // Add modal variant 4 (Sticky Slide-In)
  if ($('.modal--4').length > 0) {
    import('./components/modal4')
      .then(({ Modal4 }) => {
        const modal4 = new Modal4()
        modal4.init()
      })
  }

  // Add app download button (OS-based store link, hidden on desktop)
  if (document.querySelector('.app-download')) {
    import('./components/appDownload')
      .then(({ AppDownload }) => {
        const appDownload = new AppDownload()
        appDownload.init()
      })
  }

  // Add contrast button
  import('./components/contrastButton')
    .then(({ ContrastButton }) => {
      const contrastButton = new ContrastButton()
      contrastButton.init()
    })

  // Add tracking
  const tracking = new Tracking()
  tracking.init()

  // Inline svg
  if ($('img[src$=".svg"]').length > 0) {
    import('jquery-inline-svg')
      .then(() => {
        $('img[src$=".svg"]')
          .on('load', function () {
            $(this)
              .inlineSvg()
              .data('loaded', '1')
          })

        $('img')
          .each(function () {
            if (this.complete) {
              $(this).trigger('load')
            }
          })
      })
  }
})

$(window)
  .on('load', function () {
    // Add image gallery
    if ($('.image-gallery--1').length > 0) {
      import('./components/imageGallery1')
        .then(({ ImageGallery1 }) => {
          const imageGallery1 = new ImageGallery1()
          imageGallery1.init()
        })
    }

    // Validate Friendly Captcha before form submit
    const bonusplandatas = [...document.querySelectorAll('form.bonusplandata')]
    bonusplandatas.forEach(bonusplandatas => {
      bonusplandatas.addEventListener('submit', onFriendlyCaptchaFormSubmit)
    })
  })

async function onFriendlyCaptchaFormSubmit (event) {
  try {
    event.preventDefault()

    const formData = new FormData(event.target)
    const dataObject = Object.fromEntries(formData.entries())

    const notReadyErrorHtml = '<p class="friendly-captcha-check-error">Friendly Catpcha ist noch nicht fertig.</p>'
    const unsuccessfulErrorHtml = '<p class="friendly-captcha-check-error">Friendly Catpcha ist noch nicht fertig.</p>'
    const captcha = document.querySelector('.frc-captcha')

    if (dataObject['frc-captcha-response'] === '.UNFINISHED') {
      captcha.parentElement.innerHTML = captcha.parentElement.innerHTML + notReadyErrorHtml
      return
    }

    const solution = dataObject['frc-captcha-response']
    const url = '/?type=1500000456'
    const payload = { solution }

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })

    const result = await response.json()
    if (result === true) {
      console.log('Captcha-Überprüfung erfolgreich.')
      event.target.submit()
    } else {
      captcha.parentElement.innerHTML = captcha.parentElement.innerHTML + unsuccessfulErrorHtml
      console.log('Captcha-Überprüfung fehlgeschlagen.')
    }
  } catch (error) {
    console.error('Ein Fehler ist aufgetreten:', error)
  }
}
